import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
})
export class DialogComponent {
  message = '';
  title = '';
  type = '';
  bgColor = '';

  constructor(public modal: NgbActiveModal) {}

  setModalProperties(properties: any): any {
    this.title = properties.title || '';
    this.message = properties.message || '';
    this.type = properties.type || '';
    this.bgColor = properties.type || '';

    switch (this.type) {
      case 'success':
        this.type = 'fas fa-check';
        this.bgColor = 'bg-success';
        break;
      case 'error':
        this.type = 'fas fa-times';
        this.bgColor = 'bg-error';
        break;
      case 'info':
        this.type = 'fas fa-info';
        this.bgColor = 'bg-info';
        break;
      case 'warning':
        this.type = 'fas fa-exclamation';
        this.bgColor = 'bg-warning';
        break;
      default:
        break;
    }
  }
}
